module.exports = __webpack_public_path__ + "static/media/nadiawcake.1bca55fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/nadiawcake.jpg
// module id = 563
// module chunks = 0